import { RanaMapDisplayVectors } from "@/lib/rana-map/components/rana-map-vectors";
import { VectorFileDescriptor } from "@/types/descriptor-types";

import { getFiles, getLayersOfType, getVisibleLayersOfType } from "../../store/selectors";
import { usePublicationStore } from "../../store/store";
import { Layer } from "../../types/publication";

import { usePublicationVectorStylingOptions } from "./hooks/use-vector-styling-options";

interface PublicationMapVectorLayersProps {
  getBeforeId: (layer: Layer) => string;
}

export function PublicationMapVectorLayers({ getBeforeId }: PublicationMapVectorLayersProps) {
  const layers = usePublicationStore(getLayersOfType("vector"));
  const visibleLayers = usePublicationStore(getVisibleLayersOfType("vector"));
  const files = usePublicationStore(getFiles);

  const vectorStylingOptions = usePublicationVectorStylingOptions(
    layers.map((layer) => {
      const file = files.find((file) => file.path === layer.filePath);
      if (!file) throw new Error(`File not found for layer ${layer.id}`);
      return { fileDescriptor: file.file.descriptor as VectorFileDescriptor, layer };
    })
  );

  if (vectorStylingOptions === null) {
    return null;
  }

  const displayLayers = vectorStylingOptions.map((vectorLayer, idx) => {
    const layer = layers[idx];

    return {
      ...vectorLayer,
      isVisible: visibleLayers.some((visibleLayer) => visibleLayer.id === layer.id),
      beforeId: getBeforeId(layer),
    };
  });

  return <RanaMapDisplayVectors layers={displayLayers} />;
}
